import { Navigate, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@/context/ThemeContext';
import { OrgProvider } from '@/context/OrgContext';
import { AuthProvider } from '@/context/AuthContext';
import ProtectedRoute from '@/components/ProtectedRoute';
import Shell from '@/layout/Shell';
import Leaderboard from '@/routes/Leaderboard';
import Calendar from '@/routes/Calendar';
import Profiles from '@/routes/Profiles';
import Repositories from '@/routes/Repositories';
import Login from '@/routes/Login';
import { useData } from '@/lib/useData';

export default function App() {
  const data = useData();
  return (
    <ThemeProvider>
      <AuthProvider>
        <OrgProvider orgs={data.meta.orgs}>
          <Routes>
            {/* Public */}
            <Route path="/login" element={<Login />} />

            {/* Authenticated — everything else */}
            <Route element={<ProtectedRoute />}>
              <Route element={<Shell />}>
                <Route path="/"             element={<Leaderboard />} />
                <Route path="/calendar"     element={<Calendar />} />
                <Route path="/profiles"     element={<Profiles />} />
                <Route path="/profiles/:id" element={<Profiles />} />
                <Route path="/repositories" element={<Repositories />} />
                <Route path="*"             element={<Navigate to="/" replace />} />
              </Route>
            </Route>
          </Routes>
        </OrgProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
